var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer-bottom"},[_c('p',[_vm._v("© 2025 Mermaid图表预览. All rights reserved.")])])])])
}]

export { render, staticRenderFns }